import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../frontend/components/Header';
import Footer from '../frontend/components/Footer';

const About = () => {
  return (
    <div className="about-page">
      <Header />

      {/* ===== HERO ===== */}
      <header className="hero-editorial">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-text">
              <div className="hero-eyebrow">
                <span className="eyebrow-line"></span>
                <span>About Us</span>
              </div>
              <h1 className="hero-title">
                We build <em>trust</em>,<br />
                simplify <em>workforce</em><br />
                management.
              </h1>
              <p className="hero-lead">
                FSL Management Services helps businesses grow through reliable outsourcing and HMO solutions — crafted with care, delivered with precision.
              </p>
              <div className="hero-cta">
                <Link to="/services" className="btn-editorial">
                  Explore Services
                  <span className="btn-arrow">→</span>
                </Link>
                <Link to="/contact" className="link-editorial">
                  Talk to our team
                </Link>
              </div>
            </div>

            <div className="hero-visual">
              <div className="hero-image-frame">
                <img src="/assets/images/Hmo2.png" alt="FSL Office" />
                <div className="hero-image-tag">
                  <span className="tag-dot"></span>
                   Lagos, Nigeria
                </div>
              </div>
              
            </div>
          </div>

          <div className="hero-marquee">
            <div className="marquee-track">
              <span>Outsourcing</span><span>•</span>
              <span>HMO Solutions</span><span>•</span>
              <span>Workforce Management</span><span>•</span>
              <span>Compliance</span><span>•</span>
              <span>Strategic HR</span><span>•</span>
              <span>Outsourcing</span><span>•</span>
              <span>HMO Solutions</span><span>•</span>
              <span>Workforce Management</span><span>•</span>
              <span>Compliance</span><span>•</span>
              <span>Strategic HR</span><span>•</span>
            </div>
          </div>
        </div>
      </header>

      

      {/* ===== VALUE DRIVERS ===== */}
      <section className="values-section">
        <div className="container">
          <div className="values-header">
            <div className="values-label">
              <span>Why Choose Us</span>
            
            </div>
            <h2 className="values-title">
              Our  <br />
              <em>Value</em> driver.
            </h2>
          </div>

          <div className="values-list">
            {/* Value 1 */}
            <article className="value-item">
              <div className="value-index">
                <span>01</span>
                <div className="value-icon"><i className="fas fa-users"></i></div>
              </div>
              <div className="value-content">
                <h3>Our Clients' Human Resource Requirements Are Our Goal</h3>
                <p>
                  Your people priorities become our mission. We deliver tailored workforce solutions that align with your business objectives, enabling you to build, manage, and retain the talent needed to achieve sustainable growth.
                </p>
              </div>
              <div className="value-arrow">→</div>
            </article>

            {/* Value 2 */}
            <article className="value-item">
              <div className="value-index">
                <span>02</span>
                <div className="value-icon"><i className="fas fa-handshake"></i></div>
              </div>
              <div className="value-content">
                <h3>Reputation and Trust</h3>
                <p>
                  Our reputation is built on integrity, consistency, and delivering on our commitments. We earn our clients' trust by providing dependable solutions, maintaining the highest professional standards, and fostering long-term partnerships.
                </p>
              </div>
              <div className="value-arrow">→</div>
            </article>

            {/* Value 3 */}
            <article className="value-item">
              <div className="value-index">
                <span>03</span>
                <div className="value-icon"><i className="fas fa-award"></i></div>
              </div>
              <div className="value-content">
                <h3>We Have the Requisite Experience to Handle Your Expectations</h3>
                <p>
                  Backed by extensive industry expertise and a proven track record, we understand the complexities of workforce management and deliver practical, results-driven solutions that consistently exceed client expectations.
                </p>
              </div>
              <div className="value-arrow">→</div>
            </article>

            {/* Value 4 */}
            <article className="value-item">
              <div className="value-index">
                <span>04</span>
                <div className="value-icon"><i className="fas fa-chart-line"></i></div>
              </div>
              <div className="value-content">
                <h3>Understanding the Business Environment</h3>
                <p>
                  We understand the realities of today's business landscape. Our solutions are designed to address industry challenges, adapt to changing market conditions, and create measurable value for our clients.
                </p>
              </div>
              <div className="value-arrow">→</div>
            </article>

            {/* Value 5 */}
            <article className="value-item">
              <div className="value-index">
                <span>05</span>
                <div className="value-icon"><i className="fas fa-shield-alt"></i></div>
              </div>
              <div className="value-content">
                <h3>Compliance & Excellence</h3>
                <p>
                  We are committed to the highest standards of compliance, governance, and service excellence, ensuring every solution we deliver is ethical, compliant, and professionally executed.
                </p>
              </div>
              <div className="value-arrow">→</div>
            </article>
          </div>
        </div>
      </section>

     
     

      <Footer />

      {/* ===== STYLES ===== */}
      <style>{`
        :root {
          --cream: #FAF6EF;
          --cream-dark: #F2EBDD;
          --ink: #1A1A1A;
          --ink-soft: #4A4A4A;
          --muted: #8A8A8A;
          --accent: #E87A2E;
          --accent-dark: #C9621A;
          --line: rgba(26, 26, 26, 0.12);
        }

        .about-page {
          font-family: 'Inter', -apple-system, sans-serif;
          color: var(--ink);
          background: var(--cream);
          overflow-x: hidden;
        }

        .about-page em {
          font-family: 'Playfair Display', 'Georgia', serif;
          font-style: italic;
          font-weight: 500;
        }

        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 32px;
        }

        /* ===== HERO ===== */
        .hero-editorial {
          padding: 80px 0 40px;
          position: relative;
        }

        .hero-grid {
          display: grid;
          grid-template-columns: 1.1fr 1fr;
          gap: 80px;
          align-items: center;
          margin-bottom: 80px;
        }

        .hero-eyebrow {
          display: flex;
          align-items: center;
          gap: 16px;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--ink-soft);
          margin-bottom: 32px;
        }
        .eyebrow-line {
          width: 40px;
          height: 1px;
          background: var(--ink);
        }

        .hero-title {
          font-family: 'Playfair Display', 'Georgia', serif;
          font-size: clamp(2.5rem, 5.5vw, 5rem);
          font-weight: 500;
          line-height: 1.05;
          letter-spacing: -0.02em;
          margin-bottom: 32px;
          color: var(--ink);
        }
        .hero-title em {
          color: var(--accent);
          font-weight: 500;
        }

        .hero-lead {
          font-size: 1.15rem;
          line-height: 1.6;
          color: var(--ink-soft);
          max-width: 480px;
          margin-bottom: 40px;
        }

        .hero-cta {
          display: flex;
          align-items: center;
          gap: 32px;
        }

        .btn-editorial {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 18px 32px;
          background: var(--ink);
          color: var(--cream);
          border-radius: 100px;
          font-weight: 500;
          font-size: 15px;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        .btn-editorial:hover {
          background: var(--accent);
          color: #fff;
          transform: translateX(4px);
        }
        .btn-editorial.btn-dark {
          background: var(--ink);
          color: var(--cream);
        }
        .btn-arrow {
          transition: transform 0.3s ease;
          font-size: 18px;
        }
        .btn-editorial:hover .btn-arrow {
          transform: translateX(4px);
        }

        .link-editorial {
          color: var(--ink);
          text-decoration: none;
          font-weight: 500;
          font-size: 15px;
          position: relative;
          padding-bottom: 4px;
        }
        .link-editorial::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background: var(--ink);
          transform: scaleX(0);
          transform-origin: right;
          transition: transform 0.3s ease;
        }
        .link-editorial:hover::after {
          transform: scaleX(1);
          transform-origin: left;
        }
        .link-editorial.dark {
          color: var(--cream);
        }
        .link-editorial.dark::after {
          background: var(--cream);
        }

        /* Hero Visual */
        .hero-visual {
          position: relative;
        }
        .hero-image-frame {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          aspect-ratio: 4/5;
          background: var(--cream-dark);
        }
        .hero-image-frame img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.8s ease;
        }
        .hero-image-frame:hover img {
          transform: scale(1.04);
        }
        .hero-image-tag {
          position: absolute;
          bottom: 20px;
          left: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 18px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 100px;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.5px;
        }
        .tag-dot {
          width: 6px;
          height: 6px;
          background: var(--accent);
          border-radius: 50%;
        }

        .hero-floating-card {
          position: absolute;
          top: -30px;
          right: -30px;
          background: var(--ink);
          color: var(--cream);
          padding: 24px 28px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 16px;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
        }
        .floating-number {
          font-family: 'Playfair Display', serif;
          font-size: 3rem;
          font-weight: 500;
          line-height: 1;
          color: var(--accent);
        }
        .floating-label {
          font-size: 13px;
          line-height: 1.4;
          color: rgba(250, 246, 239, 0.7);
        }

        /* Marquee */
        .hero-marquee {
          border-top: 1px solid var(--line);
          border-bottom: 1px solid var(--line);
          padding: 24px 0;
          overflow: hidden;
          position: relative;
        }
        .marquee-track {
          display: flex;
          gap: 40px;
          white-space: nowrap;
          animation: marquee 30s linear infinite;
          font-family: 'Playfair Display', serif;
          font-size: 1.5rem;
          font-style: italic;
          color: var(--ink-soft);
        }
        .marquee-track span:nth-child(4n+2) {
          color: var(--accent);
        }
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }

        /* ===== PHILOSOPHY ===== */
        .philosophy-section {
          padding: 120px 0;
          border-bottom: 1px solid var(--line);
        }
        .philosophy-grid {
          display: grid;
          grid-template-columns: 200px 1fr;
          gap: 80px;
          align-items: start;
        }
        .philosophy-label {
          display: flex;
          flex-direction: column;
          gap: 8px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--muted);
        }
        .philosophy-label span:first-child {
          font-family: 'Playfair Display', serif;
          font-size: 14px;
          color: var(--accent);
          letter-spacing: 0;
        }
        .philosophy-quote {
          font-family: 'Playfair Display', serif;
          font-size: clamp(1.5rem, 2.8vw, 2.25rem);
          line-height: 1.35;
          font-weight: 400;
          color: var(--ink);
          margin: 0 0 40px;
          letter-spacing: -0.01em;
        }
        .philosophy-quote em {
          color: var(--accent);
        }
        .philosophy-meta {
          display: flex;
          align-items: center;
          gap: 24px;
        }
        .meta-divider {
          width: 60px;
          height: 1px;
          background: var(--ink);
        }
        .philosophy-meta strong {
          display: block;
          font-size: 15px;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .philosophy-meta span {
          font-size: 13px;
          color: var(--muted);
        }

        /* ===== VALUES ===== */
        .values-section {
          padding: 120px 0;
          background: var(--cream);
        }
        .values-header {
          display: grid;
          grid-template-columns: 200px 1fr;
          gap: 80px;
          margin-bottom: 80px;
          align-items: end;
        }
        .values-label {
          display: flex;
          flex-direction: column;
          gap: 8px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--muted);
        }
        .values-label span:first-child {
          font-family: 'Playfair Display', serif;
          font-size: 14px;
          color: var(--accent);
          letter-spacing: 0;
        }
        .values-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(2rem, 4vw, 3.5rem);
          font-weight: 500;
          line-height: 1.1;
          letter-spacing: -0.02em;
          margin: 0;
        }
        .values-title em {
          color: var(--accent);
        }

        .values-list {
          border-top: 1px solid var(--line);
        }
        .value-item {
          display: grid;
          grid-template-columns: 120px 1fr auto;
          gap: 40px;
          padding: 40px 0;
          border-bottom: 1px solid var(--line);
          align-items: center;
          transition: all 0.4s ease;
          cursor: pointer;
        }
        .value-item:hover {
          padding-left: 20px;
          background: linear-gradient(90deg, var(--cream-dark) 0%, transparent 100%);
        }
        .value-index {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .value-index span {
          font-family: 'Playfair Display', serif;
          font-size: 2rem;
          font-weight: 500;
          color: var(--ink);
          line-height: 1;
        }
        .value-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: var(--ink);
          color: var(--cream);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          transition: all 0.3s ease;
        }
        .value-item:hover .value-icon {
          background: var(--accent);
          transform: rotate(-10deg) scale(1.1);
        }
        .value-content h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.5rem;
          font-weight: 500;
          margin: 0 0 12px;
          line-height: 1.25;
          letter-spacing: -0.01em;
        }
        .value-content p {
          color: var(--ink-soft);
          line-height: 1.6;
          font-size: 15px;
          margin: 0;
          max-width: 640px;
        }
        .value-arrow {
          font-size: 28px;
          color: var(--muted);
          transition: all 0.3s ease;
        }
        .value-item:hover .value-arrow {
          color: var(--accent);
          transform: translateX(8px);
        }

        /* ===== NUMBERS ===== */
        .numbers-section {
          padding: 100px 0;
          background: var(--ink);
          color: var(--cream);
        }
        .numbers-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 40px;
        }
        .number-block {
          border-left: 1px solid rgba(250, 246, 239, 0.2);
          padding-left: 24px;
        }
        .number-value {
          font-family: 'Playfair Display', serif;
          font-size: clamp(2.5rem, 4vw, 4rem);
          font-weight: 500;
          line-height: 1;
          margin-bottom: 16px;
          color: var(--accent);
          letter-spacing: -0.02em;
        }
        .number-label {
          font-size: 14px;
          color: rgba(250, 246, 239, 0.7);
          line-height: 1.5;
        }

        /* ===== CTA ===== */
        .cta-editorial {
          padding: 120px 0;
          background: var(--cream);
        }
        .cta-inner {
          max-width: 900px;
          margin: 0 auto;
          text-align: center;
        }
        .cta-label {
          display: inline-flex;
          align-items: center;
          gap: 16px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 32px;
        }
        .cta-label span:first-child {
          font-family: 'Playfair Display', serif;
          font-size: 14px;
          color: var(--accent);
          letter-spacing: 0;
        }
        .cta-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(2.25rem, 5vw, 4.5rem);
          font-weight: 500;
          line-height: 1.05;
          letter-spacing: -0.02em;
          margin-bottom: 28px;
        }
        .cta-title em {
          color: var(--accent);
        }
        .cta-text {
          font-size: 1.15rem;
          color: var(--ink-soft);
          margin-bottom: 48px;
          line-height: 1.6;
        }
        .cta-actions {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 32px;
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 992px) {
          .hero-grid,
          .philosophy-grid,
          .values-header {
            grid-template-columns: 1fr;
            gap: 48px;
          }
          .hero-floating-card {
            top: auto;
            bottom: -20px;
            right: 20px;
          }
          .numbers-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .value-item {
            grid-template-columns: 80px 1fr;
            gap: 24px;
          }
          .value-arrow { display: none; }
        }
        @media (max-width: 640px) {
          .container { padding: 0 20px; }
          .hero-editorial { padding: 60px 0 20px; }
          .philosophy-section,
          .values-section,
          .cta-editorial { padding: 80px 0; }
          .numbers-grid { grid-template-columns: 1fr; gap: 32px; }
          .hero-cta, .cta-actions {
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
          }
          .cta-inner { text-align: left; }
          .hero-floating-card {
            position: static;
            margin-top: 24px;
            display: inline-flex;
          }
          .value-item {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .value-index {
            flex-direction: row;
            align-items: center;
          }
        }
      `}</style>
    </div>
  );
};

export default About;